module.exports = __webpack_public_path__ + "media/twitter.b09f0184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/bouncy/assets/twitter.svg
// module id = ./src/templates/bouncy/assets/twitter.svg
// module chunks = 0